import { lineChartUtil } from "@/helper/chart/line-chart.util";
import { moneyFormat } from "@/helper/format-data";
import { TooltipItem } from "@/types/tooltip-item.type";
import { useMemo } from "react";

const ParkingRevenueChartConfig = {
  colorLine: "#29AF95",
};

export const useParkingRevenueChartOption = (xAxis: string[], data: number[]) => {
  return useMemo(() => {
    const chartLineBySeries = lineChartUtil({
      colorLine: ParkingRevenueChartConfig.colorLine,
      xAxis,
    });

    return {
      ...chartLineBySeries,
      tooltip: {
        ...chartLineBySeries.tooltip,
        formatter: (params: TooltipItem[]) => {
          return params.reduce((result: string, item: TooltipItem) => {
            const wrapDiv = '<div class="flex flex-col gap-1 px-4 py-3">';
            const dateTimeHtml = `<span class='text-tiny leading-2.5 text-trend-neutral font-bold'>${item.axisValue}</span>`;
            const valueHtml = `<span class='text-xs leading-4 text-primary font-black'>${item.value !== 0 ? moneyFormat(item.value) : 0}</span>`;
            return result + wrapDiv + dateTimeHtml + valueHtml + "</div>";
          }, "");
        },
        textStyle: {},
        borderWidth: 1,
        borderColor: "#DEDBDF",
        padding: 0,
      },
      yAxis: {
        ...chartLineBySeries.yAxis,
        axisLabel: {
          color: "#555E68",
          fontSize: 11,
          formatter: (value: number) => {
            return moneyFormat(value);
          },
        },
      },
      series: [
        {
          ...chartLineBySeries.series[0],
          lineStyle: { width: 4, color: "#29AF95" },
          symbol: "circle",
          symbolSize: 8,
          showSymbol: true,
          showAllSymbol: true,
          itemStyle: {
            color: "#ffffff",
            borderColor: "#29AF95",
            borderWidth: 1,
          },
          emphasis: {
            symbolSize: 15,
            itemStyle: {
              color: "#29AF95",
              borderColor: "#FFFFFF",
              borderWidth: 4,
            },
          },
          data,
        },
      ],
    };
  }, [xAxis, data]);
};
